<ng-container #formDirective=parent-form thr-parent-form>
    <div class="row">
        <div class="col-12">
            <input type="checkbox" class="d-none" name="fdfilpComplete'" [ngModel]="client.fatca.isComplete(true)" required />

            <table class="table participants clickable mb-4">
                <thead>
                    <tr>
                        <th>{{ 'form.name'|translate }}</th>
                        <th width="50px" *ngIf="!isDisabled"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-manager [ngForOf]="client.fatca.managers">
                        <tr (click)="onEdit(manager)">
                            <td>
                                {{ manager.name }}
                            </td>
                            <td *ngIf="!isDisabled">
                                <i class="icon-check green-icon-check float-right" *ngIf="manager.isComplete()"></i>
                                <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!manager.isComplete()"></i>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>

    <ng-container *ngIf="!editing">
        <div class="row justify-content-end" *ngIf="!isDisabled">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                    {{ 'general.save'|translate }}
                </button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="editing">
        <mat-accordion class="full-data-legal" [displayMode]="'flat'" [multi]="true">
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 mb-0">
                            5.1 {{ 'full-data.general-information-about'|translate }}: {{ currentFatcaManager.name }}
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="bg-gray-gradient pt-3">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input name="fdfilpName" matInput [placeholder]="'form.name'|translate" required [disabled]="isDisabled" [(ngModel)]="currentFatcaManager.name" #nameCtrl="ngModel">
                                <mat-error *ngIf="nameCtrl.hasError('required')">
                                    {{ 'form.validation.required'|translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                                {{ 'full-data.country-city-birth-date'|translate }}
                            </h3>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <mat-select name="fdfilpCountry" [placeholder]="'form.country'|translate" required [disabled]="isDisabled" [(ngModel)]="currentFatcaManager.countryOfBirth" #countryCtrl="ngModel">
                                    <mat-option *ngFor="let country of countries" [value]="country.id.value">
                                        {{ country.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="countryCtrl.hasError('required')">
                                    {{ 'form.validation.required'|translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input name="fdfilpCity" matInput [placeholder]="'form.city'|translate" required [disabled]="isDisabled" [(ngModel)]="currentFatcaManager.cityOfBirth" #cityCtrl="ngModel">
                                <mat-error *ngIf="cityCtrl.hasError('required')">
                                    {{ 'form.validation.required'|translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <mat-label>{{ 'form.birth-date'|translate }}</mat-label>
                                <input name="fdfilpBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" ofLegalAge [disabled]="isDisabled" [placeholder]="'form.hints.date'|translate" [(ngModel)]="currentFatcaManager.birthDate"
                                    #birthDateCtrl="ngModel">
                                <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #birthDatePicker [disabled]="isDisabled"></mat-datepicker>
                                <mat-error *ngIf="birthDateCtrl.hasError('ofLegalAge')">
                                    {{ 'form.validation.of-legal-age'|translate }}
                                </mat-error>
                                <mat-error *ngIf="!birthDateCtrl.hasError('ofLegalAge') && !birthDateCtrl.valid">
                                    {{ 'form.validation.invalid.date'|translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h3 class="mat-subheading-1 text-blue font-weight-bold mb-0">
                                {{ 'full-data.tax-residence'|translate }}
                            </h3>
                            <mat-hint class="d-block mat-caption font-italic mb-3">{{ 'full-data.has-to-match-identification-address'|translate }}</mat-hint>
                        </div>
                        <div class="col-12">
                            <thr-full-data-form-address [address]="currentFatcaManager.habitualResidence" [isDisabled]="isDisabled" (change)="onHabitualResidenceChange()"></thr-full-data-form-address>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                                {{ 'full-data.mail-residence-question'|translate }}
                            </h3>
                            <mat-radio-group name="fdfilpYesNo" [(ngModel)]="currentFatcaManager.isEqualMailAddress" (ngModelChange)="onEqualMailAddressChange()" [required]="true" [disabled]="isDisabled">
                                <div class="row" [ngClass]="{'mb-3 mb-sm-4': currentFatcaManager.isEqualMailAddress}">
                                    <div class="col-6 col-sm-3">
                                        <mat-radio-button name="fdfilpNo" color="blue-gray" [value]="false">
                                            {{ 'general.no'|translate }}
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-6 col-sm-3">
                                        <mat-radio-button name="fdfilpYes" color="blue-gray" [value]="true">
                                            {{ 'general.yes'|translate }}
                                        </mat-radio-button>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="col-12" *ngIf="!currentFatcaManager.isEqualMailAddress">
                            <thr-full-data-form-address [address]="currentFatcaManager.mailResidence" [isDisabled]="isDisabled"></thr-full-data-form-address>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <thr-full-data-form-company [manager]="currentFatcaManager" [isDisabled]="isDisabled"></thr-full-data-form-company>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 mb-0">
                            5.2 {{ 'full-data.tax-residence-client'|translate }}
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="bg-gray-gradient pt-3">
                    <thr-full-data-form-legal-tax [tax]="currentFatcaManager.tax" [isDisabled]="isDisabled"></thr-full-data-form-legal-tax>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()" *ngIf="currentFatcaManager.companies.length > 0">
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 mb-0">
                            5.3 {{ 'full-data.type-person-exercising-control'|translate }}: {{ currentFatcaManager.name }}
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="bg-gray-gradient pt-3">
                    <div class="row">
                        <div class="col-4 col-lg-3 d-none d-md-block">
                            <p>{{ 'form.entity'|translate }}</p>
                        </div>
                        <div class="col-8 col-lg-9 d-none d-md-block">
                            <p>{{ 'form.select-type-person'|translate }}</p>
                        </div>
                        <ng-template ngFor let-company [ngForOf]="currentFatcaManager.companies" let-i="index">
                            <div class="col-12 d-md-none">
                                <p>{{ 'form.entity'|translate }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-lg-3">
                                <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                    {{ company.name }}
                                </h3>
                            </div>
                            <div class="col-12 d-md-none">
                                <p>{{ 'form.select-type-person'|translate }}</p>
                            </div>
                            <div class="col-12 col-md-8 col-lg-9">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <mat-select [name]="'FatcaManagerRelation' + i" [placeholder]="'form.type-person'|translate" required [disabled]="isDisabled" [(ngModel)]="company.relation" #relationCtrl="ngModel">
                                        <mat-optgroup label="{{ 'form.fatca.relation.group1'|translate }}">
                                            <mat-option [value]="FatcaManagerCompanyRelation.ENTITY_OWNERSHIP">
                                                {{ 'form.fatca.relation.1G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.ENTITY_OTHER_MEANS">
                                                {{ 'form.fatca.relation.2G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.ENTITY_HIGH_OFFICE">
                                                {{ 'form.fatca.relation.3G'|translate }}
                                            </mat-option>
                                        </mat-optgroup>

                                        <mat-optgroup label="{{ 'form.fatca.relation.group2'|translate }}">
                                            <mat-option [value]="FatcaManagerCompanyRelation.TRUSTOR_SETTLOR">
                                                {{ 'form.fatca.relation.4G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.TRUSTOR_FIDUCIARY">
                                                {{ 'form.fatca.relation.5G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.TRUSTOR_PROTECTOR">
                                                {{ 'form.fatca.relation.6G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.TRUSTOR_BENEFICIARY">
                                                {{ 'form.fatca.relation.7G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.TRUSTOR_OTHER">
                                                {{ 'form.fatca.relation.8G'|translate }}
                                            </mat-option>
                                        </mat-optgroup>

                                        <mat-optgroup label="{{ 'form.fatca.relation.group3'|translate }}">
                                            <mat-option [value]="FatcaManagerCompanyRelation.INSTRUMENT_SETTLOR">
                                                {{ 'form.fatca.relation.9G'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.INSTRUMENT_FIDUCIARY">
                                                {{ 'form.fatca.relation.AG'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.INSTRUMENT_PROTECTOR">
                                                {{ 'form.fatca.relation.BG'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.INSTRUMENT_BENEFICIARY">
                                                {{ 'form.fatca.relation.CG'|translate }}
                                            </mat-option>
                                            <mat-option [value]="FatcaManagerCompanyRelation.INSTRUMENT_OTHER">
                                                {{ 'form.fatca.relation.DG'|translate }}
                                            </mat-option>
                                        </mat-optgroup>
                                    </mat-select>
                                    <mat-error *ngIf="relationCtrl.hasError('required')">
                                        {{ 'form.validation.required'|translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 mb-0" [ngSwitch]="currentFatcaManager.companies.length">
                            <span *ngSwitchCase="0">5.3 {{ 'full-data.declaration-signature'|translate }}</span>
                            <span *ngSwitchDefault>5.4 {{ 'full-data.declaration-signature'|translate }}</span>
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="bg-gray-gradient pt-3">
                    <h3 class="mat-subheading-1 font-weight-bold text-blue">
                        {{ 'full-data.type-declaration'|translate }}
                    </h3>

                    <mat-radio-group name="fdfilpTypeSign" [value]="1" [required]="true" [disabled]="true">
                        <div class="row">
                            <div class="col-12">
                                <mat-radio-button class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="1">
                                    {{ 'form.new-contract-registration'|translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12">
                                <mat-radio-button class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="2">
                                    {{ 'form.modification-contract'|translate }}
                                </mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div class="row justify-content-between" *ngIf="!isDisabled">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()">
                    {{ 'general.cancel'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!currentFatcaManager.isComplete()" (click)="onSave()">
                    {{ 'general.continue'|translate }}
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>